import { useBizApiClient } from '../request/useBizApiClient';

export const useGetDocuments = () => {
  const [getDocuments] = useBizApiClient({
    name: 'getDocuments',
    method: 'GET',
    path: '/docsign/list_docs',
    preventStateResult: true
  });

  return getDocuments;
};

// Note: For PDF endpoints and sign endpoint with dynamic paths,
// we keep using the direct apiClient since useBizApiClient path registration
// doesn't easily support dynamic path parameters like {document_id}
// The PDF endpoints also return binary data (blobs), not JSON

